import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import EntityBottomPanel from '../../ui/entity/EntityBottomPanel'
import EntityBottomPanelBtn from '../../ui/entity/EntityBottomPanelBtn'

interface IServiceEditBottomBarProps {
  processing: boolean
  fetching: boolean
  onCancelClick: () => void
  onSaveClick: () => void
  loading: boolean
}

const ServiceEditBottomBar = (props: IServiceEditBottomBarProps) => {
  const { onSaveClick, onCancelClick, processing, fetching, loading } = props

  return (
    <EntityBottomPanel>
      <div className='flex justify-between'>
        <div />
        <MoonLoader sizeUnit={'px'} size={27} color={'#405264'} loading={processing || fetching} />

        <div className='flex flex-row'>
          <div className='mr2'>
            <EntityBottomPanelBtn isActive={!fetching && !processing} onClick={onCancelClick}>
              Cancel
            </EntityBottomPanelBtn>
          </div>

          <EntityBottomPanelBtn
            isActive={!fetching && !processing && !loading}
            disabled={loading}
            onClick={onSaveClick}
            aria-busy={loading}
          >
            <MoonLoader sizeUnit={'px'} size={15} color={'#FFFFFF'} loading={loading} />
            {!loading && 'Save'}
          </EntityBottomPanelBtn>
        </div>
      </div>
    </EntityBottomPanel>
  )
}

export default ServiceEditBottomBar



// WEBPACK FOOTER //
// ./src/components/services/edit/ServiceEditBottomBar.tsx